import React from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    const { nav } = state
    return {
        navTheme: nav.navTheme
    }
}


const Breadcrumb = ({ children, navTheme }) => {
    return (
        <div className={`breadcrumb ${navTheme}`}>
            { children }
        </div>
    )
}

export default connect(mapStateToProps)(Breadcrumb)
